import { Action } from 'redux';

import { DeleteExtractRefresh } from '../../../bootstrap/redux/actions/AppActionTypes';
import { IExtractTaskInfo } from '../../../extractTask/models/IExtractTaskInfo';

export interface DeleteExtractRefreshAction extends Action {
  tasks: IExtractTaskInfo[];
}

export function deleteExtractRefresh(tasks: IExtractTaskInfo[]): DeleteExtractRefreshAction {
  return {
    type: DeleteExtractRefresh,
    tasks
  };
}
